module.exports = __webpack_public_path__ + "img/logo-top.4f0b63b.svg";